import ReactPaginate from 'react-paginate'

import ArrowLeftIcon from '@/assets/homepage/icon/arrow-left.svg?react'
import ArrowRightIcon from '@/assets/homepage/icon/arrow-right.svg?react'

import style from './Pagination.module.scss'

interface PaginationProps {
  onPageChange: (selectedItem: {selected: number}) => void
  pageCount: number
  currentPage: number
  hrefBuilder: (pageIndex: number) => string
}

const NextPageButton = memo(function NextPageButton() {
  return (
    <>
      <div className={style.PaginationButtonText}>Next</div>
      <ArrowRightIcon aria-hidden className={style.PaginationButtonIcon} />
    </>
  )
})
const PrevPageButton = memo(function NextPageButton() {
  return (
    <>
      <ArrowLeftIcon aria-label='previous page' className={style.PaginationButtonIcon} />
      <div className={style.PaginationButtonText}>Prev</div>
    </>
  )
})

export default memo<PaginationProps>(function Pagination({
  onPageChange,
  pageCount,
  currentPage,
  hrefBuilder,
}) {
  return (
    <nav className={style.PaginationContainer}>
      <ReactPaginate
        breakLabel={'\u2026'}
        nextLabel={<NextPageButton />}
        onPageChange={onPageChange}
        pageRangeDisplayed={3}
        pageCount={pageCount}
        previousLinkClassName={style.PaginationButton}
        nextLinkClassName={style.PaginationButton}
        previousLabel={<PrevPageButton />}
        containerClassName={style.Pagination}
        pageLinkClassName={style.Page}
        breakClassName={style.PaginationEllipsis}
        activeLinkClassName={style.Active}
        disabledClassName={style.DisableButton}
        hrefBuilder={hrefBuilder}
        forcePage={currentPage}
      />
    </nav>
  )
})
